// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"2c73f98a","193":"c98f428e"}[chunkId] + ".chunk.js";
};